export const LoginProviderTypes = {
   PASSWORD: 1,
   APPLE: 2,
   GOOGLE: 3
};